<template>
  <div>
    <h3 style="text-align: center;">APORTE A TITULO DE DONACION</h3>
    <p>La Fundación Apoyo es una entidad sin ánimo de lucro reconocida por el gobierno Colombiano y calificada en el
régimen tributario especial del impuesto sobre la renta. En virtud del objeto social, se desarrollan actividades de
apoyo a la educación y fomento empresarial, para lo cual entre otras fuentes de financiamiento, cuenta con
donaciones recibidas. Es por ello que se ha diseñado el “Plan de Donación Periódica” a partir de un valor sugerido,
en el cual usted podrá mensualmente realizar su aporte. Desde ya agradecemos su donación.</p>
    </div>
</template>

<script>
export default {
  name: 'aporte_titulo_donacion',
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>